import { createAction, props } from '@ngrx/store';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

export interface NotificationAction {
  label: string;
  actionType: string;
  payload?: any;
}

export interface Notification {
  id: string;
  severity: NotificationSeverity;
  title: string;
  summary: string;
  detail?: string;
  actionType?: string;
  timestamp: Date;
  duration?: number; // Auto-dismiss duration in milliseconds (0 = never)
  actions?: NotificationAction[];
  dismissible?: boolean; // Whether user can manually dismiss (default: true)
  blocking?: boolean; // Whether to show backdrop and center (modal-like behavior)
  icon?: string; // Custom icon class (e.g., 'pi pi-exclamation-triangle')
}

export const ShowNotification = createAction(
  '[Notification] Show',
  props<{ notification: Notification }>(),
);

export const DismissNotification = createAction('[Notification] Dismiss', props<{ id: string }>());

export const ClearAllNotifications = createAction('[Notification] Clear All');

export const NotificationActionClicked = createAction(
  '[Notification] Action Clicked',
  props<{ notificationId: string; action: NotificationAction }>(),
);

// User status toggle confirmation actions
export const ConfirmUserStatusToggle = createAction(
  '[Settings Users] Confirm User Status Toggle',
  props<{ userId: string; newStatus: boolean; userEmail: string }>(),
);

export const CancelUserStatusToggle = createAction(
  '[Settings Users] Cancel User Status Toggle',
  props<{ userId: string; originalStatus: boolean }>(),
);
